import React from "react";
import { withStyles, FormGroup, FormControlLabel, Switch } from "@material-ui/core";

import { COLORS } from "../../theme/colors";

export const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 33,
    height: 18,
    padding: 0,
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: COLORS.purple,
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: COLORS.white,
      border: `6px solid ${COLORS.white}`,
    },
  },
  thumb: {
    width: 14,
    height: 14,
    marginTop: 1,
  },
  track: {
    borderRadius: 11,
    backgroundColor: COLORS.darks[0][25],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export function SwitchButton({ checked = false, handleChange = {}, label = "" }) {
  return (
    <FormGroup>
      <FormControlLabel
        control={<IOSSwitch checked={checked} onChange={handleChange} />}
        label={label}
        style={{ margin: 0 }}
      />
    </FormGroup>
  );
}
